module.exports = __webpack_public_path__ + "media/customizations/ryeranchlife/logo-8e000ec35a05952fd968122fcbdae3e6.png";